import {Inject, Injectable} from '@angular/core';
import {UserService as UserApiService} from '../../modules/apiModule/api/user.service';
import {DOCUMENT} from '@angular/common';
import {map} from 'rxjs/operators';
import {UserTableSettingsDto} from '../../modules/apiModule/model/user-table-settings-dto';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserTableSettingsService {

    public initComplete = new BehaviorSubject(false);

    storage: Storage | undefined;

    constructor(
        private userService: UserApiService,
        @Inject(DOCUMENT) private document: Document,
    ) {
        console.log('INIT_USER_TABLE_SETTINGS');
        // document.defaultView?.localStorage?.setItem('foo', JSON.stringify({}));
        this.storage = document.defaultView?.localStorage;
        this.userService.apiUserTablesettingsGet({tableCode: ''})
            .pipe(map(v => v.values))
            .subscribe((v: UserTableSettingsDto[]) => {
                console.log('UserTableSettings', v);
                v.forEach((item) => {
                    if (!item || !item.tableCode) return;
                    const savingTableList = item.tablesList?.filter(Boolean).length ? item.tablesList : undefined;
                    savingTableList && this.storage?.setItem(item.tableCode, JSON.stringify(savingTableList));
                    this.storage?.setItem(item.tableCode + '-sort', JSON.stringify(item.sort));
                });
                this.initComplete.next(true);
            });
    }

    setItem(key: string, value: string[], sort: { columnName: string, ascending: boolean | null }): void {
        if (!key.endsWith('-table') && !key.endsWith('-table-sort')) return;
        this.userService.apiUserTablesettingsPut({
            apiUserTablesettingsPutRequest: {
                tableCode: key,
                tablesList: value,
                sort
            }
        })
            .subscribe(v => {
                console.log(v);
            });
    }

}
